// Helper function for Dutch number formatting
function formatDutchPrice(cents) {
  const euros = (cents / 100).toFixed(2);
  const parts = euros.split('.');
  // Add thousand separator (.)
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  // Join with comma as decimal separator
  return parts.join(',');
}

document.addEventListener('bundler:total_cart_values', function (e) {
  const {
    total_amount_original = 0,
    total_amount_discounted = 0,
    discount_amount = 0,
    discounted_cart_object = null,
  } = e.detail;

  // DEBUG LOGS
  console.log('=== BUNDLER EVENT FIRED ===');
  console.log('total_amount_original:', total_amount_original);
  console.log('total_amount_discounted:', total_amount_discounted);
  console.log('discount_amount:', discount_amount);
  console.log('Cart items:', discounted_cart_object?.items);

  // VAT configuration
  const VAT_RATE = 0.21; // 21% VAT rate for Netherlands
  
  // Calculate subtotal excluding VAT
  const subtotalExcludingVat = total_amount_original;
  
  // Update subtotal display (now excluding VAT)
  const subtotalWithoutTaxElement = document.getElementById('cart-price_subtotal');
  const formattedSubtotalExVat = formatDutchPrice(subtotalExcludingVat);
  if (subtotalWithoutTaxElement) {
    subtotalWithoutTaxElement.textContent = `€${formattedSubtotalExVat}`;
  }

  const cartPriceTax = document.getElementById('cart-price_tax');

  // Calculate and track all discounts.
  // The authoritative discount is what Shopify actually took off the cart. The bundler's own
  // `discount_amount` is rounded per unit (e.g. 275 * 5% = 13.75 -> 14 cents * 25 = 350) while
  // Shopify allocates across the line (343.75 -> 344), and both describe the SAME discount as
  // the line_level_discount_allocations below. Summing them double counted the volume discount,
  // so derive it from the totals instead.
  let totalDiscount = Math.max(0, total_amount_original - total_amount_discounted);
  let compareAtDiscounts = 0;
  let automaticDiscounts = 0; // Tracked for the per-line badges only, never summed into the total
  let promises = [];

  if (discounted_cart_object && discounted_cart_object.items) {
    discounted_cart_object.items.forEach((item) => {
      const itemElement = document.querySelector(`[data-cart-variant="${item.variant_id}"]`);
      
      // Check for automatic discounts on line items
      if (item.line_level_discount_allocations && item.line_level_discount_allocations.length > 0) {
        item.line_level_discount_allocations.forEach((discount) => {
          automaticDiscounts += discount.amount;
          
          // Update display to show discount
          if (itemElement) {
            const originalPrice = item.original_line_price;
            const discountedPrice = item.final_line_price;
            
            const oldPriceElements = itemElement.querySelectorAll('[data-old-price]');
            oldPriceElements.forEach(oldPriceEl => {
              if (oldPriceEl) {
                oldPriceEl.textContent = `€${(originalPrice / 100).toFixed(2).replace('.', ',')}`;
                oldPriceEl.style.display = 'block';
              }
            });

            const newPriceElements = itemElement.querySelectorAll('[data-new-price]');
            newPriceElements.forEach(newPriceEl => {
              if (newPriceEl) {
                newPriceEl.textContent = `€${(discountedPrice / 100).toFixed(2).replace('.', ',')}`;
                newPriceEl.setAttribute('data-excl-price', discountedPrice);
              }
            });
            
            // Add discount badge
            const discountBadgeContainer = itemElement.querySelector('[data-discount-badge]');
            if (discountBadgeContainer && !discountBadgeContainer.querySelector('.discount-badge')) {
              const discountPercentage = Math.round((discount.amount / originalPrice) * 100);
              const badge = document.createElement('span');
              badge.className = 'discount-badge inline-block ml-2 bg-red-500 text-white font-bold px-2 py-1 rounded text-xs';
              badge.textContent = `-${discountPercentage}%`;
              discountBadgeContainer.appendChild(badge);
            }
          }
        });
      }
      
      // Fetch full product info to get compare_at_price
      const promise = fetch(`/products/${item.handle}.js`)
        .then((response) => response.json())
        .then((product) => {
          const variant = product.variants.find(v => v.id == item.variant_id) || 
                         product.variants.find(v => v.title == item.variant_title);
          
          if (!variant) return;
          
          // Only check compare_at_price if no automatic discount was applied
          if (!item.line_level_discount_allocations || item.line_level_discount_allocations.length === 0) {
            if (variant.compare_at_price && variant.compare_at_price > variant.price) {
              const itemDiscount = (variant.compare_at_price - variant.price) * item.quantity;
              compareAtDiscounts += itemDiscount;
              
              // Update display for this item
              if (itemElement) {
                const oldPriceElements = itemElement.querySelectorAll('[data-old-price]');
                oldPriceElements.forEach(oldPriceEl => {
                  if (oldPriceEl) {
                    oldPriceEl.textContent = `€${((variant.compare_at_price * item.quantity) / 100).toFixed(2).replace('.', ',')}`;
                    oldPriceEl.style.display = 'block';
                  }
                });

                const newPriceElements = itemElement.querySelectorAll('[data-new-price]');
                newPriceElements.forEach(newPriceEl => {
                  if (newPriceEl) {
                    newPriceEl.textContent = `€${(item.line_price / 100).toFixed(2).replace('.', ',')}`;
                    newPriceEl.setAttribute('data-excl-price', item.line_price);
                  }
                });
              }
            } else if (itemElement) {
              // Hide old price if there's no discount
              const oldPriceElements = itemElement.querySelectorAll('[data-old-price]');
              oldPriceElements.forEach(oldPriceEl => {
                if (oldPriceEl) {
                  oldPriceEl.style.display = 'none';
                }
              });
            }
          }
        })
        .catch(error => {
          console.error(`Error fetching product data for ${item.handle}:`, error);
        });
      
      promises.push(promise);
    });
  }

  // Update all prices after all fetch requests complete
  Promise.all(promises).then(() => {
    // Automatic/bundler discounts are already inside totalDiscount; compare_at savings are shown
    // on top because Shopify never books them as a discount.
    const combinedDiscount = totalDiscount + compareAtDiscounts;
    
    console.log('=== AFTER PROMISES ===');
    console.log('totalDiscount:', totalDiscount);
    console.log('compareAtDiscounts:', compareAtDiscounts);
    console.log('automaticDiscounts:', automaticDiscounts);
    console.log('combinedDiscount:', combinedDiscount);
    console.log('total_amount_discounted:', total_amount_discounted);
    
    // Update subtotal to full price (incl. compare-price differences)
    const fullSubtotal = total_amount_original + compareAtDiscounts;
    if (subtotalWithoutTaxElement) {
      subtotalWithoutTaxElement.textContent = `€${formatDutchPrice(fullSubtotal)}`;
    }

    // Update total discount display (all discounts: compare prices + codes + automatic)
    const totalDiscountElement = document.getElementById('cart-price_discount');
    if (totalDiscountElement && combinedDiscount > 0) {
      const formattedDiscount = (combinedDiscount / 100).toFixed(2).replace('.', ',');
      totalDiscountElement.textContent = `€-${formattedDiscount}`;

      // Show discount row
      document.querySelectorAll('[data-cart-discount]').forEach((el) => {
        el.classList.add('flex');
        el.classList.remove('hidden');
      });
    } else {
      // Hide discount row if no discounts
      document.querySelectorAll('[data-cart-discount]').forEach((el) => {
        el.classList.remove('flex');
        el.classList.add('hidden');
      });
    }

    // Use Shopify's already-discounted total — compare_at_price discounts are
    // shown visually only and must not be subtracted again here.
    const actualDiscountedTotal = total_amount_discounted;
    console.log('actualDiscountedTotal:', actualDiscountedTotal);

    const shippingThreshold = 8181;
    const shippingCostInCents = 661;
    
    let finalTotalWithShipping = actualDiscountedTotal;
    
    // Add shipping if needed
    if (actualDiscountedTotal < shippingThreshold) {
      finalTotalWithShipping = actualDiscountedTotal + shippingCostInCents;
    }
    
    console.log('finalTotalWithShipping:', finalTotalWithShipping);
    
    // Update the total price display (incl. BTW 21%)
    const totalPriceElement = document.getElementById('cart-price_total');
    if (totalPriceElement) {
      const totalInclBtw = Math.round(finalTotalWithShipping * 1.21);
      totalPriceElement.textContent = `€${formatDutchPrice(totalInclBtw)}`;
      totalPriceElement.setAttribute('data-excl-price', finalTotalWithShipping);
    }
  });

  // Updated shipping threshold logic to match Dutch shipping rates
  const shippingThreshold = 8181; // 99 euros in cents (free shipping threshold)
  const shippingCostInCents = 661; // €6,6115 in cents (ex. VAT)
  const progressBarElement = document.getElementById('shipping-progress-bar');
  const shippingMessageElement = document.getElementById('shipping-message');
  const shippingCostElement = document.getElementById('cart-shipping_amount');
  const shippingCosts = document.getElementById('shipping-costs');
  const shippingCostElementContainer = document.getElementById('cart-shipping_amount-container');

  // Calculate final total including shipping
  let finalTotalWithShipping = total_amount_discounted;
  
  if (progressBarElement) {
    const progressPercentage = Math.min((total_amount_discounted / shippingThreshold) * 100, 100);
    progressBarElement.style.width = `${progressPercentage}%`;
  }

  if (total_amount_discounted < shippingThreshold) {
    // Add shipping cost to total
    finalTotalWithShipping = total_amount_discounted + shippingCostInCents;
    
    const amountLeft = ((shippingThreshold - total_amount_discounted) / 100).toFixed(2).replace('.', ',');
    shippingMessageElement.innerHTML = `Nog 
        <span class="font-bold" id="shipping-threshold-left">
        €${amountLeft}
        </span>
        voor <span class="font-bold text-success">gratis</span> verzending`;
    
    if (shippingCostElement) {
      shippingCostElementContainer.classList.remove('hidden');
      shippingCostElement.textContent = '€6,61';
      shippingCostElement.classList.remove('text-success');
      shippingCostElement.classList.add('text-black');

      const cartPriceTaxPrice = cartPriceTax.getAttribute('data-vat-price');
      let shippingVAT = ((shippingCostInCents * 1.21) - shippingCostInCents);
      let totalVAT = ((parseFloat(cartPriceTaxPrice) + shippingVAT) / 100).toFixed(2).replace('.', ',');
      cartPriceTax.textContent = `€${totalVAT}`;
    }

    if (shippingCosts) {
      shippingCosts.style.display = 'flex';
    }
  } else {
    // Free shipping - no additional cost
    shippingMessageElement.innerHTML = `Je hebt <span class="font-bold text-success">gratis</span> verzending`;
    if (shippingCostElement) {
      shippingCostElementContainer.classList.remove('hidden');
      shippingCostElement.textContent = 'Gratis';
      shippingCostElement.classList.add('text-success');
      shippingCostElement.classList.remove('text-black');
    }
    
    if (shippingCosts) {
      shippingCosts.style.display = 'none';
    }
  }

  // NOTE: Total price update happens in Promise.all above, not here anymore
});

// Rest of the code stays the same...
function increaseQuantity(event, id) {
  event.preventDefault();
  const input = document.querySelector(`#Quantity-Input-${id}`);
  if (input) {
    const currentValue = parseInt(input.value) || 0;
    const max = input.getAttribute('max');
    const step = parseInt(input.getAttribute('step')) || 1;
    const newValue = currentValue + step;
    
    if (!max || newValue <= parseInt(max)) {
      input.value = newValue;
      input.dispatchEvent(new Event('change', { bubbles: true }));
      updateCartQuantity(id, newValue);
    }
  }
}

function decreaseQuantity(event, id) {
  event.preventDefault();
  const input = document.querySelector(`#Quantity-Input-${id}`);
  if (input) {
    const currentValue = parseInt(input.value) || 0;
    const min = parseInt(input.getAttribute('min')) || 0;
    const step = parseInt(input.getAttribute('step')) || 1;
    const newValue = currentValue - step;
    
    if (newValue >= min) {
      input.value = newValue;
      input.dispatchEvent(new Event('change', { bubbles: true }));
      updateCartQuantity(id, newValue);
    }
  }
}

function updateCartQuantity(lineItem, quantity) {
  const formData = {
    'line': lineItem,
    'quantity': quantity
  };
  
  fetch('/cart/change.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(formData)
  })
  .then(response => response.json())
  .then(data => {
    location.reload();
  })
  .catch((error) => {
    console.error('Error updating cart:', error);
  });
}

document.addEventListener('DOMContentLoaded', function() {
  const totalPriceElement = document.getElementById('cart-price_total');
  if (totalPriceElement && totalPriceElement.textContent) {
    const currentText = totalPriceElement.textContent.trim();
    const numericValue = currentText.replace(/[^0-9]/g, '');
    if (numericValue) {
      totalPriceElement.textContent = `€${formatDutchPrice(parseInt(numericValue))}`;
    }
  }

  const removeButtons = document.querySelectorAll('cart-remove-button a');
  removeButtons.forEach(button => {
    button.addEventListener('click', function(e) {
      e.preventDefault();
      const url = this.getAttribute('href');
       
      this.style.opacity = '0.5';
      this.style.pointerEvents = 'none';
      
      fetch(url, {
        method: 'GET',
      })
      .then(() => {
        location.reload(); 
      })
      .catch(error => {
        console.error('Error removing item:', error);
        this.style.opacity = '1';
        this.style.pointerEvents = 'auto';
      });
    });
  });

  const quantityInputs = document.querySelectorAll('.quantity__input');
  quantityInputs.forEach(input => {
    let timeout;
    input.addEventListener('change', function() {
      clearTimeout(timeout);
      const lineItem = this.getAttribute('data-index');
      const quantity = parseInt(this.value) || 0;
      
      timeout = setTimeout(() => {
        updateCartQuantity(lineItem, quantity);
      }, 500);
    });
  });
});